import { v4 as uuid } from 'uuid';
import { mergeMap, of } from "rxjs";
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';
import * as FlatModels from "@medsurf/flat-models";

@Injectable()
export class AnnotationTargetEntityFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  //</editor-fold>

  //<editor-fold desc="Requests">
  
  static getNewInstance(id: string,
                        annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType,
                        tipType: FlatModels.AnnotationEntityModels.TipType = FlatModels.AnnotationEntityModels.TipType.enum.dot,
                        position: FlatModels.PointSharedModels.Point = { x: 0.5, y: 0.5 }) {
    const annotationTarget: FlatModels.AnnotationTargetEntityModels.AnnotationTarget = {
      id,
      endType: tipType,
      position,
      color: null,
      endRadius: null,
      annotation: annotation.id
    };
    return annotationTarget;
  }
  
  static addAnnotationTarget(store: Store,
                             id: string,
                             annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType,
                             tipType: FlatModels.AnnotationEntityModels.TipType = FlatModels.AnnotationEntityModels.TipType.enum.dot,
                             position: FlatModels.PointSharedModels.Point = { x: 0.5, y: 0.5 }) {
    // Get New Instance
    const annotationTarget = AnnotationTargetEntityFacade.getNewInstance(id, annotation, tipType, position);
    
    // Add Annotation Target
    return store.dispatch(new FlatActions.AnnotationTargetEntityActions.AddEntity(annotationTarget)).pipe(
      mergeMap((data) => of({data, annotationTarget})),
    );
  }
  
  static getCopyInstance(store: Store,
                         id: string,
                         annotation: FlatModels.AnnotationEntityModels.Marker | FlatModels.AnnotationEntityModels.FreeForm) {
    // Get Data
    const typedAnnotationTargets = store.selectSnapshot(FlatStates.AnnotationTargetEntityState.typedEntities$);
    
    // Get Annotation Target
    const annotationTarget = structuredClone(typedAnnotationTargets[id]);
    
    // Update Annotation Target
    annotationTarget.id = uuid();
    annotationTarget.annotation = annotation.id;
    
    return annotationTarget;
  }

  //</editor-fold>
}
